"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FABAnalytics = void 0;
class FABAnalytics {
    /** Init */
    init() {
        jQuery('.fab-links').each(function () {
            let ID = jQuery(this).data('id');
            jQuery(this).on('click', function () {
                jQuery.ajax({
                    url: '/wp-json/fab/v1/clicked',
                    type: 'POST',
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('X-WP-Nonce', window.FAB_PLUGIN.nonce.clicked);
                    },
                    data: {
                        post_id: ID
                    },
                    error: (xhr, status, error) => {
                        console.error('Error:', error);
                    }
                });
            });
        });
    }
}
exports.FABAnalytics = FABAnalytics;
